type calculateMonthlyPaymentNOArgs = {
  amount: number;
  duration: number;
  interestRate: number;
  monthlyFee?: number;
};
export const calculateMonthlyPaymentNO = (
  args: calculateMonthlyPaymentNOArgs
) => {
  const { amount, duration, interestRate, monthlyFee = 30 } = args;

  const monthlyTerms = duration * 12;
  const termInterest = interestRate / 100 / 12;
  const tenure = Math.round(monthlyTerms);
  const value =
    (amount * termInterest) / (1 - 1 / Math.pow(1 + termInterest, tenure)) +
    Math.round(monthlyFee);
  return Math.ceil(value);
};
